import { defaults } from "lodash-es";
interface PageConfig {
  width: number;
  height: number;
  gutters: {
    top: number;
    bottom: number;
    right: number;
    left: number;
  };
}

export class PrintPage implements PageConfig {
  constructor(args?: PageConfig) {
    Object.assign(
      this,
      defaults(args || {}, {
        width: 210,
        height: 297,
        gutters: {
          top: 7,
          bottom: 14,
          left: 7,
          right: 7,
        },
      })
    );
  }

  width!: number;
  height!: number;
  gutters!: { top: number; bottom: number; right: number; left: number };
  get contentSize() {
    return {
      width: this.width - this.gutters.left - this.gutters.right,
      height: this.height - this.gutters.top - this.gutters.bottom,
    };
  }
}
